"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOVE_OPTIONS = void 0;
exports.MOVE_OPTIONS = {
    NONE: 0,
    PREV: 1,
    NEXT: 2,
    BOTH: 3,
};
